<template>
    <div id="main" class="select-modal">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("produto") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("vendas")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'ven-produto',
                                            })
                                        "
                                        >{{ $t("produtos") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? `${$route.params.id} - ${
                                                      loadingName
                                                          ? $t(
                                                                "carregando"
                                                            )
                                                          : name
                                                  }`
                                                : $t("novo")
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'ven-produto' })"
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs nav-tabs-main">
                    <router-link
                        v-if="isUpdate && permissaoDadosCadastrais.read"
                        tag="li"
                        :to="{
                            name: `ven-produto-dados-cadastrais-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                            query: {
                                dadoscadastrais: $route.query.dadoscadastrais 
                                    ? $route.query.dadoscadastrais
                                    : null,
                                politicacomercial: abaSelecionada,
                                // Descomentar quando sair a aba de Analise Comercial
                                // analisecomercial: $route.query.analisecomercial
                                //    ? $route.query.analisecomercial
                                //    : null
                            }
                        }"
                    >
                        <a>{{ $t("dados-cadastrais") }}</a>
                    </router-link>
                    <router-link
                        tag="li"
                        :to="{
                            name: `ven-produto-politica-comercial-${
                                isUpdate ? 'edit' : 'new'
                            }`,
                        }"
                    >
                        <a>{{ $t("politica-comercial") }}</a>
                    </router-link>
                </ul>

                <ul class="nav nav-tabs nav-tabs-children">
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="listaPermissoes[aba].read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">{{ $t(aba) }}</a>
                    </li>
                </ul>

                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ $t(abas[abaSelecionada]) }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="listaPermissoes[aba].read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        {{ $t(aba) }}
                    </b-dropdown-item>
                </b-dropdown>

                <!-- DESCONTO X QUANTIDADE -->
                <DescontoQuantidade
                    ref="tabDescontoQuantidade"
                    v-if="
                        abasAbertas['desconto-qtde'] &&
                        listaPermissoes['desconto-qtde'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'desconto-qtde'"
                />
                <!-- PACOTE/KIT -->
                <PacoteKit
                    ref="tabPacoteKit"
                    v-if="
                        abasAbertas['pacote-kit'] &&
                        listaPermissoes['pacote-kit'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'pacote-kit'"
                />
                <!-- CAMPANHA -->
                <Campanha
                    ref="tabCampanha"
                    v-if="
                        abasAbertas['campanha'] &&
                        listaPermissoes['campanha'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'campanha'"
                />

                <!-- AGREGADO -->
                <Agregado
                    ref="tabAgregado"
                    v-if="
                        abasAbertas['agregado'] &&
                        listaPermissoes['agregado'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'agregado'"
                />

                <!-- SIMILAR -->
                <Similar
                    ref="tabSimilar"
                    v-if="
                        abasAbertas['similar'] &&
                        listaPermissoes['similar'].read &&
                        isUpdate
                    "
                    v-show="abas[abaSelecionada] == 'similar'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";

// Abas
import DescontoQuantidade from "@/components/vendas/produto/abas/politica-comercial/DescontoQuantidade";
import PrecoPrazo from "@/components/vendas/produto/abas/politica-comercial/PrecoPrazo";
import PacoteKit from "@/components/vendas/produto/abas/politica-comercial/PacoteKit";
import PacoteKitGrade from "@/components/vendas/produto/abas/politica-comercial/PacoteKitGrade";
import Campanha from "@/components/vendas/produto/abas/politica-comercial/Campanha";
import Agregado from "@/components/vendas/produto/abas/politica-comercial/Agregado";
import Similar from "@/components/vendas/produto/abas/politica-comercial/Similar";
import Multiplo from "@/components/vendas/produto/abas/politica-comercial/Multiplo";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        DescontoQuantidade,
        //PrecoPrazo,
        PacoteKit,
        PacoteKitGrade,
        Campanha,
        Agregado,
        Similar,
        Multiplo,
    },
    data() {
        return {
            id: 0,
            abaSelecionada: 0,
            // Seguir nome na tabela app_tela e usar estes nomes no dicionário para criação dinâmica de listaPermissoes e abasAbertas
            abas: [
                "desconto-qtde",
                //'preco-prazo',
                "pacote-kit",
                //'pacote-kit-grade',
                "campanha",
                "agregado",
                "similar",
                //"multiplo",
            ],
            abasAbertas: {},
            permissaoDadosCadastrais: false,
            permissaoAnaliseComercial: false,
            permissaoPoliticaComercial: false,
            listaPermissoes: {},
            isUpdate: false,
            isChanged: false,
            name: null,
            loadingName: false,
            service: new VenProdutoService(this.$http, this.$router),
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
        if (this.$route.query.politicacomercial && this.$route.params.id) {
            this.changeTab(this.$route.query.politicacomercial < this.abas.length 
                ? this.$route.query.politicacomercial
                : 0
            );
        }
    },
    created() {
        this.id = this.$route.params.id;

        if (this.$route.params.id) this.isUpdate = true;

        this.permissaoPoliticaComercial = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-politica-comercial"
        );

        if (
            (!this.isUpdate && !this.permissaoPoliticaComercial.create) ||
            (this.isUpdate && !this.permissaoPoliticaComercial.update) ||
            !this.permissaoPoliticaComercial.read
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "produto" },
            });
        } else {
            if (this.isUpdate) this.loadName();
            // Criação dinâmica de listaPermissoes e abasAbertas baseado no nome das tabs
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "vendas",
                    "produtos",
                    `ven-produto-politica-comercial-${value}`
                );
            }

            this.permissaoDadosCadastrais = this.hasPermissionAccess(
                "vendas",
                "produtos",
                "ven-produto-dados-cadastrais"
            );

            this.permissaoAnaliseComercial = this.hasPermissionAccess(
                "vendas",
                "produtos",
                "ven-produto-analise-comercial"
            );

            // Pegar dinâmicamente a primeira aba que estivar com permissão de leitura para a mesma iciciar visível
            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    methods: {
        loadName() {
            this.loadingName = true;
            this.service
                .loadName(this.$route.params.id)
                .then((res) => {
                    this.name = res.content.descricao;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.loadingName = false;
                });
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav-tabs-main {
            margin-bottom: 10px;
        }
        .nav-tabs-children {
            margin-bottom: 20px;
            li > a {
                text-transform: capitalize;
            }
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .nav.nav-tabs {
            flex-wrap: wrap;

            &::after {
                content: "";
                flex: auto;
            }

            & li {
                margin-right: 0;
                margin-left: 20px;

                &.active > a {
                    color: $primary-color-click;
                }
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
